import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default [
	{
		path: '/',
		name: 'main',
		component: () => import(/* webpackChunkName: "Main" */ '@/pages/MainPage.vue')
	},
	{
		path: '/dashboard',
		name: 'dashboard',
		component: () => import(/* webpackChunkName: "Dashboard" */ '../pages/dashboard/DashboardPage.vue'),
		children: [],
		meta: {
			roles: ['ROLE_ADMIN', 'ROLE_COMPANY', 'ROLE_USER']
		}
	},
	{
		path: '/admin',
		name: 'admin',
		component: () => import(/* webpackChunkName: "Admin" */ '../pages/admin/AdminPage.vue'),
		children: [
			// {
			//     path: '/admin/drones',
			//     name: 'admin-drones',
			//     component: () => import( /* webpackChunkName: "admin-drones" */ '../pages/admin/Drones.vue'),
			// },
			// {
			//     path: '/admin/droneTasks',
			//     name: 'admin-droneTasks',
			//     component: () => import( /* webpackChunkName: "admin-droneTasks" */ '../pages/admin/DroneTasks.vue'),
			// },
			{
				path: '/admin/project',
				name: 'admin-project',
				component: () => import(/* webpackChunkName: "admin-project" */ '../pages/admin/Project.vue')
			},
			{
				path: '/admin/sites',
				name: 'admin-sites',
				component: () => import(/* webpackChunkName: "admin-sites" */ '../pages/admin/Sites.vue')
			},
			{
				path: '/admin/solar-module-report',
				name: 'admin-solar-module-report',
				component: () => import(/* webpackChunkName: "admin-solar-module-report" */ '../pages/admin/SolarExamineReport.vue')
			},
			// {
			//     path: '/admin/stations',
			//     name: 'admin-stations',
			//     component: () => import( /* webpackChunkName: "admin-stations" */ '../pages/admin/Stations.vue'),
			// },
			{
				path: '/admin/settings',
				name: 'admin-settings',
				component: () => import(/* webpackChunkName: "admin-settings" */ '../pages/admin/Settings.vue')
			},
			{
				path: '/admin/ai-analysis',
				name: 'admin-ai-analysis',
				component: () => import(/* webpackChunkName: "admin-ai-analysis" */ '../pages/admin/AIReport.vue')
			},
			{
				path: '/admin/users',
				name: 'admin-users',
				component: () => import(/* webpackChunkName: "admin-users" */ '../pages/admin/Users.vue'),
				meta: {
					roles: ['ROLE_ADMIN', 'ROLE_USER']
				}
			},
			{
				path: '/admin/companies',
				name: 'admin-companies',
				component: () => import(/* webpackChunkName: "admin-companies" */ '../pages/admin/CompaniesPage.vue'),
				meta: {
					roles: ['ROLE_ADMIN']
				}
			},
			{
				path: '/admin/company-managers',
				name: 'admin-company-managers',
				component: () => import(/* webpackChunkName: "admin-company-managers" */ '../pages/admin/CompanyManagersPage.vue'),
				meta: {
					roles: ['ROLE_ADMIN']
				}
			},
			{
				path: '/admin/panel-planning',
				name: 'admin-panel-planning',
				component: () => import(/* webpackChunkName: "admin-panel-planning" */ '../pages/admin/PanelPlanning.vue'),
				meta: {
					roles: ['ROLE_ADMIN']
				}
			},
			{
				path: '/admin/panel-products',
				name: 'admin-panel-products',
				component: () => import(/* webpackChunkName: "admin-panel-products" */ '../pages/admin/PanelProducts.vue'),
				meta: {
					roles: ['ROLE_ADMIN']
				}
			},
			{
				path: '/admin/image-alignment',
				name: 'admin-image-alignment',
				component: () => import(/* webpackChunkName: "admin-image-alignment" */ '../pages/admin/ImageAlignment.vue'),
				meta: {
					roles: ['ROLE_ADMIN']
				}
			}
		],
		meta: {
			roles: ['ROLE_ADMIN', 'ROLE_USER']
		}
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import(/* webpackChunkName: "Login" */ '../pages/auth/LoginPage.vue')
	}

];
